import {
  Box,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import { ClientApproversTabPanel } from './ClientApproversTabPanel';
import { ClientProvider } from 'features';
import { ClientUsersTabPanel } from './ClientUsersTabPanel';
import { ClientRolesTabPanel } from './ClientRolesTabPanel';
import { ClientTermsAndConditionsTabPanel } from './ClientTermsAndConditionsPage';
import { ClientVendorsTabPanel } from './ClientVendorsTabPanel';
import { UnitOfMeasurementsTabPanel } from './UnitOfMeasurementsTabPanel';
import { ClientAccountsPage } from './ClientAccountsPage';

export interface ClientSettingsLandingPageProps {}

export const ClientSettingsLandingPage = (
  props: ClientSettingsLandingPageProps
) => {
  return (
    <ClientProvider>
      <Box as="section">
        <Stack>
          {/* <Heading size={'xl'} pb={4}>
          Administrator Settings
        </Heading> */}
          <Tabs
            //   variant={'soft-rounded'}
            orientation="vertical"
            size={'lg'}
            isLazy={true}
            //   isFitted
          >
            <TabList minW={[0, 256]} pr={[0, 8]}>
              <Tab>Company</Tab>
              <Tab>Users</Tab>
              <Tab>Roles</Tab>
              <Tab>Chart of Accounts</Tab>
              <Tab>Approvers</Tab>
              <Tab>Vendors</Tab>
              <Tab>Units of Measurement</Tab>
              <Tab>Terms & Conditions</Tab>
            </TabList>
            <TabPanels>
              <TabPanel>Nothing to see here</TabPanel>
              <ClientUsersTabPanel />
              <ClientRolesTabPanel />
              <TabPanel>
                <ClientAccountsPage />
              </TabPanel>
              <ClientApproversTabPanel />
              <ClientVendorsTabPanel />
              <UnitOfMeasurementsTabPanel />
              <ClientTermsAndConditionsTabPanel />
            </TabPanels>
          </Tabs>
        </Stack>
      </Box>
    </ClientProvider>
  );
};
